var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconVector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4h12M5.333 4V2.666a1.333 1.333 0 011.334-1.333h2.667a1.333 1.333 0 011.333 1.333V4m2 0v9.333a1.333 1.333 0 01-1.333 1.333H4.667a1.333 1.333 0 01-1.333-1.333V4h9.333z",
    stroke: "#616161",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/delete_icon_vector.3d588248.svg";
export { SvgDeleteIconVector as ReactComponent };